"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _themeUi = require("theme-ui");

var _useControlledState2 = _interopRequireDefault(require("../../hooks/useControlledState"));

var _ButtonIcon = _interopRequireDefault(require("../ButtonIcon/ButtonIcon"));

var _SelectEnhanced = _interopRequireDefault(require("../SelectEnhanced/SelectEnhanced"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _SelectListItem = _interopRequireDefault(require("./SelectListItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var IconPlus = function IconPlus(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
  }));
};

IconPlus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};

var arrayMove = function arrayMove(array, from, to) {
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
};

var SelectListSelectContainer = function SelectListSelectContainer(_ref) {
  var children = _ref.children,
      innerProps = _ref.innerProps,
      selectProps = _ref.selectProps,
      setValue = _ref.setValue;

  var handleRemoveValue = function handleRemoveValue(value) {
    var newValue = selectProps.value.filter(function (item) {
      return item.value !== value;
    });
    setValue(newValue, 'remove-value');
  };

  var handleDragEnd = function handleDragEnd(event) {
    var source = event.source,
        destination = event.destination;
    var oldIndex = source.index;
    var newIndex = destination.index;
    var newValue = arrayMove(selectProps.value, oldIndex, newIndex);
    setValue(newValue, 'reorder-value');
  };

  return (0, _themeUi.jsx)("div", {
    sx: {
      bg: 'white',
      variant: selectProps.isDisabled ? 'forms.input.:disabled' : 'forms.input',
      borderWidth: 'thin',
      borderStyle: 'solid',
      borderRadius: 'small',
      p: 0
    }
  }, (0, _themeUi.jsx)("div", _extends({}, innerProps, {
    sx: {
      position: 'relative'
    }
  }), children), selectProps.value.length > 0 && (0, _themeUi.jsx)(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDragEnd
  }, (0, _themeUi.jsx)(_reactBeautifulDnd.Droppable, {
    droppableId: selectProps.id + "-droppable"
  }, function (provided, snapshot) {
    return (0, _themeUi.jsx)("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef,
      sx: {
        px: 3,
        borderWidth: 'thin',
        borderColor: 'secondary'
      }
    }), (0, _themeUi.jsx)("div", {
      sx: {
        borderTopWidth: 'thin',
        borderTopColor: 'neutral.1',
        borderTopStyle: 'solid'
      }
    }), (0, _themeUi.jsx)("div", {
      sx: {
        py: 2
      }
    }, selectProps.value.map(function (item, index) {
      return (0, _themeUi.jsx)(_reactBeautifulDnd.Draggable, {
        key: item.value,
        draggableId: item.value,
        isDragDisabled: selectProps.isDisabled,
        index: index,
        disableInteractiveElementBlocking: false
      }, function (provided, snapshot) {
        return (0, _themeUi.jsx)("div", _extends({
          ref: provided.innerRef
        }, provided.draggableProps, {
          sx: {
            py: 2
          },
          style: _extends({}, provided.draggableProps.style)
        }), (0, _themeUi.jsx)(_SelectListItem["default"], {
          isDragging: snapshot.isDragging,
          dragHandleProps: provided.dragHandleProps,
          onRemove: function onRemove() {
            return handleRemoveValue(item.value);
          },
          disabled: selectProps.isDisabled
        }, item.label));
      });
    }), provided.placeholder));
  })));
};

SelectListSelectContainer.propTypes = {
  children: _propTypes["default"].node,
  setValue: _propTypes["default"].func,
  selectProps: _propTypes["default"].shape({
    value: _propTypes["default"].array,
    id: _propTypes["default"].string,
    isDisabled: _propTypes["default"].bool
  }),
  innerProps: _propTypes["default"].shape({})
};

var SelectListValueContainer = function SelectListValueContainer(props) {
  var children = props.children,
      selectProps = props.selectProps,
      getStyles = props.getStyles;
  var valueContainerStyles = getStyles('valueContainer', props);
  var placeholderStyles = getStyles('placeholder', props);
  var InputComponent = children.find(function (child) {
    if (child && child.type) {
      return child.type.name === 'Input' || child.type.name === 'SelectListInput';
    }
  });
  return (0, _themeUi.jsx)("div", {
    style: valueContainerStyles
  }, selectProps.inputValue.length === 0 && (0, _themeUi.jsx)(_Text["default"], {
    style: placeholderStyles
  }, selectProps.placeholder), (0, _themeUi.jsx)("div", null, InputComponent));
};

SelectListValueContainer.propTypes = {
  children: _propTypes["default"].node,
  getStyles: _propTypes["default"].func,
  selectProps: _propTypes["default"].shape({
    placeholder: _propTypes["default"].string,
    inputValue: _propTypes["default"].string
  })
};

var SelectListIndicatorsContainer = function SelectListIndicatorsContainer(props) {
  var getStyles = props.getStyles,
      children = props.children,
      selectProps = props.selectProps,
      setValue = props.setValue,
      naturalOptions = props.naturalOptions,
      clearManagedValue = props.clearManagedValue;

  var handleCreateValue = function handleCreateValue() {
    if (selectProps.inputValue && selectProps.inputValue.length > 0) {
      setValue({
        value: selectProps.inputValue,
        label: selectProps.inputValue
      }, 'create-option');
      clearManagedValue();
    }
  };

  var indicatorsContainerStyles = getStyles('indicatorsContainer', props);
  return (0, _themeUi.jsx)("div", {
    style: indicatorsContainerStyles
  }, (0, _themeUi.jsx)(_ButtonIcon["default"], {
    disabled: selectProps.isDisabled,
    icon: IconPlus,
    ariaLabel: "Add",
    onClick: handleCreateValue,
    sx: {
      mr: 1
    }
  }), naturalOptions.length > 0 && children);
};

SelectListIndicatorsContainer.propTypes = {
  children: _propTypes["default"].node,
  getStyles: _propTypes["default"].func,
  selectProps: _propTypes["default"].shape({
    inputValue: _propTypes["default"].string,
    isDisabled: _propTypes["default"].bool
  }),
  setValue: _propTypes["default"].func,
  naturalOptions: _propTypes["default"].array,
  clearManagedValue: _propTypes["default"].func
};
SelectListIndicatorsContainer.defaultProps = {
  naturalOptions: []
};

var SelectList = function SelectList(_ref2) {
  var id = _ref2.id,
      name = _ref2.name,
      values = _ref2.values,
      options = _ref2.options,
      ExternalInputValue = _ref2.inputValue,
      onInputChange = _ref2.onInputChange,
      onChange = _ref2.onChange,
      props = _objectWithoutPropertiesLoose(_ref2, ["id", "name", "values", "options", "inputValue", "onInputChange", "onChange"]);

  var _useThemeUI = (0, _themeUi.useThemeUI)(),
      theme = _useThemeUI.theme;

  var inputStyles = (0, _themeUi.css)(theme.forms.input)(theme);

  var _useControlledState = (0, _useControlledState2["default"])(ExternalInputValue, onInputChange),
      inputValue = _useControlledState[0],
      setInputValue = _useControlledState[1];

  var clearInputValue = function clearInputValue() {
    setInputValue('');
  };

  var handleInputChange = function handleInputChange(value, action) {
    if (action.action === 'input-change') {
      setInputValue(value);
    }
  };

  var handleCreateOption = function handleCreateOption(value) {
    onChange({
      currentTarget: {
        name: name || id,
        value: {
          label: value,
          value: value
        }
      }
    });
    clearInputValue();
  };

  return (0, _themeUi.jsx)(_SelectEnhanced["default"], _extends({}, props, {
    id: id,
    name: name,
    as: _creatable["default"],
    isMulti: true,
    options: options,
    onChange: onChange
  }, !options && inputValue.length === 0 && {
    menuIsOpen: false
  }, {
    escapeClearsValue: false,
    isClearable: false,
    value: values,
    inputValue: inputValue,
    onInputChange: handleInputChange,
    onCreateOption: handleCreateOption,
    backspaceRemovesValue: false,
    components: {
      MultiValue: function MultiValue() {
        return null;
      },
      IndicatorsContainer: function IndicatorsContainer(innerProps) {
        return (0, _themeUi.jsx)(SelectListIndicatorsContainer, _extends({
          naturalOptions: options,
          clearManagedValue: clearInputValue
        }, innerProps));
      },
      SelectContainer: SelectListSelectContainer,
      ValueContainer: SelectListValueContainer
    },
    styles: {
      control: function control(provided, state) {
        return _extends({
          borderColor: 'transparent',
          ml: function ml(theme) {
            return "-" + theme.borderWidths.thin + "px";
          },
          mr: function mr(theme) {
            return "-" + theme.borderWidths.thin + "px";
          },
          mt: function mt(theme) {
            return "-" + theme.borderWidths.thin + "px";
          },
          mb: function mb(theme) {
            return "-" + theme.borderWidths.thin + "px";
          },
          bg: 'transparent'
        }, state.isFocused && _extends({}, inputStyles[':focus'], {
          borderColor: 'secondary',
          '&:hover': inputStyles[':focus']
        }));
      }
    }
  }));
};

SelectList.propTypes = {
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string,
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  onChange: _propTypes["default"].func.isRequired,
  inputValue: _propTypes["default"].string,
  onInputChange: _propTypes["default"].func
};
SelectList.defaultProps = {
  values: [],
  inputValue: ''
};
var _default = SelectList;
exports["default"] = _default;